import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import NewsCarousel from 'hb-react/shared/apps/Topics/containers/TopicHomeContainer/Components/NewsCarousel';

// eslint-disable-next-line no-restricted-imports
import style from '../../../index.module.scss';

const NewsWrapper = ({ topic, whitelabelURL, getBgColor }) => {
  const { news } = topic;

  const posts = news.map((element) => ({
    ...element,
    customClassNames: 'one-whole bloc-item-container',
  }));

  let urlNews = Routes.topic_news_path(topic.id);

  urlNews = whitelabelURL
    ? urlNews.replace(Routes.topic_path(topic.id), '')
    : urlNews;

  return (
    topic.home_config.section_news_enabled &&
    !isEmpty(posts) &&
    posts.length >= 3 && (
      <div
        className="flex soft-double--bottom"
        style={{
          backgroundColor: getBgColor(
            topic.home_config.section_news_body_background_color,
          ),
        }}
      >
        <div className="relative push-half--bottom soft-half-push flex-grow--1 width--100-percent">
          <h2
            className="h1 soft-double--ends"
            style={{
              color: topic.home_config.section_news_title_color,
              backgroundColor:
                topic.home_config.section_news_title_background_color,
              textAlign: topic.home_config.section_news_title_alignment,
            }}
          >
            <div className={style['homepage-container']}>
              {topic.home_config.section_news_title || __('News')}
            </div>
          </h2>
          <div
            className={style['homepage-container']}
            data-testid="carousel-news"
          >
            <NewsCarousel items={posts} />
          </div>
          <Link to={urlNews}>
            <div className="text--center push--ends">
              <span
                className="soft-half"
                style={{
                  color:
                    topic.home_config.section_news_button_color || '#C3D0D8',
                  backgroundColor:
                    topic.home_config.section_news_button_background_color ||
                    '#1781BA',
                }}
              >
                {__('See more')}
              </span>
            </div>
          </Link>
        </div>
      </div>
    )
  );
};

export default NewsWrapper;
